/**
 * Cari bakiye kartı: tek görünüm (admin işaretleri).
 * Borç = −(Sipariş + Ödeme + Bakım), Alacak = Hakediş + İade Faturası + Tahsilat.
 * @param {number} adminArti
 * @param {number} adminEksi
 * @param {boolean} [_isTechView] - geriye dönük uyumluluk; artık kullanılmaz
 */
export function computeCariBalanceDisplay(adminArti, adminEksi, _isTechView) {
  const arti = Number(adminArti) || 0;
  const eksi = Number(adminEksi) || 0;
  return { borc: -eksi, alacak: arti, bakiye: arti - eksi };
}
